<template>
  <header ref="navbar" style="width: 100%" :class="['navbar', { scrolled }]">
    <div class="container">
      <!-- Left: Logo + Links -->
      <div class="nav-left" style="display: flex">
        <a href="#" class="nav-link">
          <div class="logo">
            <img :src="logoSodaSoft" alt="SodaSoft" height="40" />
            <span class="logo-text">SodaSoft</span>
          </div>
        </a>
        <nav class="nav-links" :class="{ open: isMobileMenuOpen }">
          <a
            v-for="item in leftItems"
            :key="item.id"
            :id="item.id"
            :href="'#' + item.hash"
            class="nav-link"
          >
            {{ item.label }}
          </a>
        </nav>
      </div>
      <div class="mobile-sheet" v-if="isMobileMenuOpen" @click.self="isMobileMenuOpen = false">
        <div class="mobile-sheet-content">
          <nav>
            <a v-for="item in leftItems" :key="item.id" class="sheet-link" href="#">
              {{ item.label }}
            </a>
            <a href="#login" class="sheet-link">Log in</a>
            <button id="btn-request-demo" @click="handleMobileRequestDemo">Request a Demo</button>
          </nav>
        </div>
      </div>

      <!-- Right: Buttons -->
      <div class="nav-right">
        <a id="btn-login" href="#login" class="login-link">Log in</a>
        <Button id="btn-request-demo" label="Request a Demo" @click="showDemo = true" />
        <!-- Hamburger -->
        <button class="hamburger" @click="isMobileMenuOpen = !isMobileMenuOpen">
          <i class="pi pi-bars"></i>
        </button>
      </div>
    </div>

    <!-- Request Demo Dialog -->
    <Dialog
      v-model:visible="showDemo"
      modal
      style="width: 90%; max-width: 400px"
      class="demo-dialog"
    >
      <template #header>
        <div style="padding: 1rem 20px; font-weight: 600; font-size: 1.25rem">Request a Demo</div>
      </template>
      <div class="p-fluid">
        <div class="field">
          <label for="demo-email">Email</label>
          <InputText id="demo-email" v-model="demoEmail" type="email" required />
        </div>
        <div class="field mt-2">
          <label for="demo-phone">Contact No</label>
          <InputText id="demo-phone" v-model="demoPhone" type="text" />
        </div>
        <div class="field mt-2">
          <label for="demo-message">Message</label>
          <Textarea id="demo-message" v-model="demoMessage" rows="4" />
        </div>
        <div class="flex justify-content-end mt-3">
          <Button id="btn-request-demo" icon="pi pi-check" label="Submit" @click="submitDemo" />
        </div>
      </div>
    </Dialog>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import logoSodaSoft from '@/assets/logo.svg'

const leftItems = ref([
  { label: 'Features', id: 'menu-features', hash: 'features' },
  // { label: 'For Developers', id: 'menu-developers', hash: 'for-developers' },//
  { label: 'Why Choose Us', id: 'menu-why', hash: 'why-choose-us' },
  { label: 'Contact', id: 'menu-contact', hash: 'contact' },
])

const showDemo = ref(false)
const demoEmail = ref('')
const demoPhone = ref('')
const demoMessage = ref('')
const isMobileMenuOpen = ref(false)
const scrolled = ref(false)

function handleScroll() {
  scrolled.value = window.scrollY > 10
}

function submitDemo() {
  console.log('Demo Request:', demoEmail.value, demoPhone.value, demoMessage.value)
  showDemo.value = false
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

function handleMobileRequestDemo() {
  showDemo.value = true
  isMobileMenuOpen.value = false
}
</script>

<style scoped>
/* Base Styles */

* {
  font-family: 'Geist', sans-serif;
  font-optical-sizing: auto;

  font-style: normal;
}

.demo-dialog .p-dialog-header {
  padding: 1rem 1.5rem !important;
}

.p-fluid {
  padding: 20px;
}

.navbar {
  position: sticky;
  top: 0;
  z-index: 999;
  background: white;
  transition:
    background-color 0.3s,
    box-shadow 0.3s;
  border-bottom: 1px solid #eee;
  padding: 0px 30px;
}

.navbar.scrolled {
  background-color: rgba(0, 115, 255, 0.05);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(5px);
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0rem;
  max-width: 1340px;
  margin: auto;
  /* border: 2px solid red; */
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 1.2rem;
  color: #000c1a;
}

.logo-icon {
  height: 26px;
  width: auto;
}

.logo-text {
  color: #000c1a;
}

.logo-icon path {
  fill: #cc3333;
}

/* Links */
.nav-links {
  display: flex;
  gap: 1.5rem;
}

.nav-link {
  font-size: 14px;
  color: #898989;
  text-decoration: none;
}

.nav-link:hover {
  color: #0073ff;
}

/* Right */
.nav-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.login-link {
  font-size: 0.9rem;
  color: #444;
  text-decoration: none;
}

.login-link:hover {
  color: #0073ff;
}

/* Hamburger */
.hamburger {
  display: none;
  background: none;
  border: none;
  font-size: 1.4rem;
}

.nav-left {
  align-items: center;
  gap: 35px;
}

#btn-request-demo {
  background-color: #2a68ed !important;
  color: white;
  padding: 7px 13px;
  border-radius: 6px;
  font-size: 14px;
}

#btn-request-demo:hover {
  background-color: #3874f6 !important;
}

#btn-login {
  color: black;
}

/* Input + Textarea Styling */
.p-inputtext,
.p-inputtextarea {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #0f172a;
  background-color: white;
  box-shadow: none;
  margin-top: 5px;
}

.p-inputtext::placeholder,
.p-inputtextarea::placeholder {
  color: #94a3b8;
}

.p-inputtext:focus,
.p-inputtextarea:focus {
  border-color: #2563eb;
  outline: none;
  box-shadow: 0 0 0 1px #2563eb;
}

.mobile-sheet {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

.mobile-sheet-content {
  background-color: white;
  padding: 2rem 1.5rem;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  animation: slideUp 0.3s ease-out;
}

.sheet-link {
  display: block;
  padding: 12px 0;
  font-size: 16px;
  color: #0f172a;
  text-decoration: none;
  border-bottom: 1px solid #f1f5f9;
}

.sheet-link:hover {
  color: #2563eb;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .nav-links {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    background: white;
    padding: 1rem;
    border-top: 1px solid #ddd;
    display: none;
  }

  .nav-links.open {
    display: flex;
  }

  .hamburger {
    display: block;
  }

  #btn-request-demo {
    padding: 6px 8px;
    border-radius: 6px;
    font-size: 10px;
  }

  .login-link {
    font-size: 12px;
    color: #444;
    text-decoration: none;
  }
}
</style>
